<template>
    <span v-if="!!periodicity">
        <template v-if="!!upperCase">{{ periodicity.value.toUpperCase() }}</template>
        <template v-else>{{ periodicity.value }}</template>
    </span>
</template>

<script>
    import {periodicityOptions} from '@/constants/periodicity-constants';

    export default {
        name: "PeriodicityName",
        props: {
            value: String,
            upperCase: Boolean
        },
        data: function () {
            return {
                periodicity: !!this.value ? this.findPeriodicityByKey(this.value) : null
            }
        },
        computed: {
            periodicityOptions() {
                return periodicityOptions;
            }
        },
        methods: {
            findPeriodicityByKey(key) {
                return periodicityOptions.find(periodicity => (periodicity.key === key));
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.periodicity = this.findPeriodicityByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>